export default [
  // APP反馈
  {
    path: '/feedback',
    component: () => import('../../views/feedback/Index.vue'),
    name: 'feedback',
    meta: {
      auth: 1,
      visibleShare: true,
      backgroundClass: 'bg-light-gray',
    },
  },
  // APP反馈详情
  {
    path: '/feedback-detail-:id',
    component: () => import('../../views/feedback/Detail.vue'),
    name: 'feedback-detail',
    meta: {
      auth: 1,
      visibleShare: true,
      backgroundClass: 'bg-light-gray',
    },
  },
  // APP反馈
  {
    path: '/feedback-question-type',
    component: () => import('../../views/feedback/Type.vue'),
    name: 'feedback-question-type',
    meta: {
      auth: 1,
      visibleShare: true,
      backgroundClass: 'bg-white-gray',
    },
  },
  // APP反馈提交
  {
    path: '/feedback-create',
    component: () => import('../../views/feedback/Create.vue'),
    name: 'feedback-create',
    meta: {
      auth: 1,
      visibleShare: true,
      backgroundClass: 'bg-light-gray',
    },
  },
  // APP反馈追加
  {
    path: '/feedback-supplement-:id',
    component: () => import('../../views/feedback/Create.vue'),
    name: 'feedback-supplement',
    meta: {
      auth: 1,
      visibleShare: true,
      backgroundClass: 'bg-light-gray',
    },
  },
  // APP反馈结果
  {
    path: '/feedback-result',
    component: () => import('../../views/feedback/Result.vue'),
    name: 'feedback-result',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-light-gray',
    },
  },
];
